/**
 * Price Calculator Module
 * Handles all price calculations for custom product fields
 */
export class PriceCalculator {
  constructor(options) {
    this.config = options
  }

  getVariationPrice(variationId) {
    return parseFloat(this.config.variationPrices[variationId]) || 0
  }

  getUtforandePrice(selectedValue) {
    if (this.config.utforandeData && this.config.utforandeData[selectedValue]) {
      return parseFloat(this.config.utforandeData[selectedValue].price) || 0
    }
    return 0
  }

  calculateTotalPrice(options) {
    const { variationId, selectedUtforande, bredd, hojd, totalHeight, opening, overljus } = options

    let totalPrice = this.getVariationPrice(variationId) + this.getUtforandePrice(selectedUtforande)

    if (bredd > 0 || hojd > 0 || totalHeight > 0 || opening > 0) {
      if (this.config.calculationType === 'total_height' && bredd > 0) {
        totalPrice += this.config.breddPrice * bredd + this.config.heightPrice * hojd
      } else if (this.config.calculationType === 'opening_height' && bredd > 0) {
        totalPrice +=
          this.config.breddPrice * bredd +
          this.config.transomPrice * overljus +
          this.config.heightPrice * hojd
      } else if (this.config.calculationType === 'opening_height_split' && bredd > 0) {
        totalPrice += this.config.breddPrice * bredd + this.config.totalHeightPrice * totalHeight
      } else if (this.config.calculationType === 'fast_racke' && bredd > 0) {
        totalPrice += this.config.breddPrice * bredd + this.config.heightPrice * hojd
      }
    }

    // Return price with tax using proper rounding (0.5 rounds up)
    return Math.floor(totalPrice * this.config.taxRate + 0.5)
  }
}
